import { Dialog, DialogContent } from '@mui/material';
import get from 'lodash/get';
import React, { useEffect, useState } from 'react';

// Dev only
const logEvent = (event) => {
  const log = { type: event.type, detail: event.detail };
  console.log(log);
  return log;
};

const Whereby = ({ appointment }) => {
  const [userCount, setUserCount] = useState(0);
  const [showDialog, setShowDialog] = useState(false);

  const observer = new MutationObserver((mutations_list) => {
    mutations_list.forEach((mutation) => {
      mutation.addedNodes.forEach((added_node) => {
        if (added_node.id === 'whereby-embed') {
          added_node.addEventListener('participantupdate', (e) => {
            const count = get(e, 'detail.count', 0);

            // Needs to be set within callback because of
            // event listener being unable to reference state value
            setUserCount((state) => {
              if (state < 2) {
                state = count;
              }

              return state;
            });
          });

          observer.disconnect();
        }
      });
    });
  });

  observer.observe(document.querySelector('#appointment-container'), {
    subtree: false,
    childList: true,
  });

  useEffect(() => {
    const cdn = document.createElement('script');
    cdn.src = 'https://cdn.srv.whereby.com/embed/v1.js';
    cdn.type = 'module';

    document.body.appendChild(cdn);
  }, []);

  useEffect(() => {
    if (userCount >= 2) setShowDialog(false);
    else if (userCount > 0) setShowDialog(true);
  }, [userCount]);

  const auth = JSON.parse(localStorage.getItem('O_AUTH_KEY'));
  const { firstName, lastName } = auth.user;
  return (
    <>
      <Dialog
        hideBackdrop
        open={showDialog}
        fullWidth
        maxWidth="xs"
        sx={{
          fontSize: 20,
          postion: 'relative',
          bottom: "70%",
        }}>
        <DialogContent
          sx={{ fontSize: 20, color: '#3F5C76', textAlign: 'center' }}>
          Sit tight! Your sleep specialist will be joining in a few minutes.
        </DialogContent>
      </Dialog>
      <whereby-embed
        id="whereby-embed"
        style={{
          width: '100%',
          height: `calc(100% - 64px)`
        }}
        minimal
        room={`${appointment.roomUrl}?displayName=${firstName} ${lastName}&leaveButton=off&settingsButton=off&breakout=off&timer=on&participantCount=off&people=off`}></whereby-embed>
    </>
  );
};

export default Whereby;
